"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SMALL_IMAGE_RIGHT = exports.SMALL_IMAGE_PARAMS = exports.SMALL_IMAGE_LEFT = exports.SMALL_IMAGE_DESKTOP_WIDTH = exports.LARGE_IMAGE_PARAMS = exports.LARGE_IMAGE_DESKTOP_WIDTH = exports.LARGE_IMAGE_DESKTOP_HEIGHT = exports.LARGE_IMAGE = void 0;
var _utils = require("../../utils");
const LARGE_IMAGE = exports.LARGE_IMAGE = 'large-image';
const SMALL_IMAGE_LEFT = exports.SMALL_IMAGE_LEFT = 'small-image-left';
const SMALL_IMAGE_RIGHT = exports.SMALL_IMAGE_RIGHT = 'small-image-right';
const LARGE_IMAGE_DESKTOP_WIDTH = exports.LARGE_IMAGE_DESKTOP_WIDTH = 610;
const LARGE_IMAGE_DESKTOP_HEIGHT = exports.LARGE_IMAGE_DESKTOP_HEIGHT = 365;
const LARGE_IMAGE_PARAMS = exports.LARGE_IMAGE_PARAMS = (0, _utils.getImageParamsAndSizes)({
  desktopWidth: LARGE_IMAGE_DESKTOP_WIDTH,
  mobileWidth: LARGE_IMAGE_DESKTOP_WIDTH
});
const SMALL_IMAGE_DESKTOP_WIDTH = exports.SMALL_IMAGE_DESKTOP_WIDTH = 300;
const SMALL_IMAGE_PARAMS = exports.SMALL_IMAGE_PARAMS = (0, _utils.getImageParamsAndSizes)({
  desktopWidth: SMALL_IMAGE_DESKTOP_WIDTH,
  mobileWidth: SMALL_IMAGE_DESKTOP_WIDTH
});
